"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _UserUtil = require("../../utils/UserUtil");

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyPanel = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CompanyPanel, _Component);

  function CompanyPanel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CompanyPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CompanyPanel.__proto__ || (0, _getPrototypeOf2.default)(CompanyPanel)).call.apply(_ref, [this].concat(args))), _this), _this.changeRole = function (user, event) {
      var role = event.target.value;
      var _this$props = _this.props,
          company = _this$props.company,
          changeRole = _this$props.changeRole;

      var confirmText = "Haluatko varmasti p\xE4ivitt\xE4\xE4 k\xE4ytt\xE4j\xE4lle " + user.first_name + " " + user.last_name + " roolin " + (0, _UserUtil.getRole)({ role: role }) + "?";
      if (confirm(confirmText)) {
        changeRole(company.id, user.id, role);
      }
    }, _this.removeUser = function (user, event) {
      event.preventDefault();
      var _this$props2 = _this.props,
          company = _this$props2.company,
          removeUser = _this$props2.removeUser;

      var confirmText = "Haluatko varmasti poistaa k\xE4ytt\xE4j\xE4n " + user.first_name + " " + user.last_name + " yrityksen k\xE4ytt\xE4jist\xE4?";
      if (confirm(confirmText)) {
        removeUser(company.id, user.id);
      }
    }, _this.approveUser = function (user, event) {
      event.preventDefault();
      var _this$props3 = _this.props,
          company = _this$props3.company,
          approveUser = _this$props3.approveUser;

      var confirmText = "Haluatko varmasti hyv\xE4ksy\xE4 k\xE4ytt\xE4j\xE4n " + user.first_name + " " + user.last_name + " yrityksen k\xE4ytt\xE4j\xE4ksi?";
      if (confirm(confirmText)) {
        approveUser(company.id, user.id);
      }
    }, _this.onSubmit = function (values) {
      _this.props.updateBillingInfo(_this.props.company.id, values);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CompanyPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          company = _props.company,
          _props$fields = _props.fields,
          business_id = _props$fields.business_id,
          company_name = _props$fields.company_name,
          address = _props$fields.address,
          postal_area = _props$fields.postal_area,
          postal_code = _props$fields.postal_code;

      business_id.onChange(company.business_id);
      company_name.onChange(company.name);
      address.onChange(company.address.street_address);
      postal_area.onChange(company.address.postal_area);
      postal_code.onChange(company.address.postal_code);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h1",
            { className: "h3" },
            "Oma yritys"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Ta\u0308lla\u0308 sivulla voit muokata yrityksen laskutustietoja ja hallinnoida ka\u0308ytta\u0308jia\u0308.",
            _react2.default.createElement("br", null),
            "Jos haluat muuttaa yrityksen y-tunnusta, ole yhteydessa\u0308 myyntiin tai asiakaspalveluun."
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h2",
            { className: "h4 form-title form-title-js" },
            "Laskutustiedot"
          ),
          this.renderBillingInfo()
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h2",
            { className: "h4" },
            "K\xE4ytt\xE4j\xE4t"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Alla na\u0308et saman y-tunnuksen alle rekistero\u0308ityneet ka\u0308ytta\u0308ja\u0308t. Ylla\u0308pita\u0308ja\u0308 \u2013ka\u0308ytta\u0308ja\u0308t voivat rajattomasti korottaa muita profiileja Ka\u0308ytta\u0308jista\u0308 Ylla\u0308pita\u0308jiksi seka\u0308 poistaa profiileja. Ylla\u0308pita\u0308jilla\u0308 on myo\u0308s pa\u0308a\u0308sy kaikkiin y-tunnuksen nimissa\u0308 luotuihin kuljetusraportteihin. Ka\u0308ytta\u0308ja\u0308t na\u0308keva\u0308t ",
            _react2.default.createElement(
              _reactRouter.Link,
              { to: "/omat-ajot" },
              "\u201DKuljetusraportit\u201D"
            ),
            " \u2013osiossa vain omat kuljetussuorituksensa."
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "table",
            { className: "table users-table" },
            _react2.default.createElement(
              "thead",
              null,
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "th",
                  null,
                  "Nimi:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "S\xE4hk\xF6posti:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "Rooli:"
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  "\xA0"
                )
              )
            ),
            _react2.default.createElement(
              "tbody",
              null,
              this.renderUsers()
            )
          )
        ),
        this.renderNewUsersTable()
      );
    }
  }, {
    key: "renderBillingInfo",
    value: function renderBillingInfo() {
      var _props$fields2 = this.props.fields,
          business_id = _props$fields2.business_id,
          company_name = _props$fields2.company_name,
          address = _props$fields2.address,
          postal_code = _props$fields2.postal_code,
          postal_area = _props$fields2.postal_area;
      var company = this.props.company;

      return _react2.default.createElement(
        "form",
        { id: "billingInfoForm", className: "col col-xs-12", onSubmit: this.props.handleSubmit(this.onSubmit) },
        _react2.default.createElement(
          "div",
          { className: "company-fields-js" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-sm-4" },
              _react2.default.createElement(
                "label",
                { htmlFor: "business_id_ro", className: "control-label" },
                "Y-tunnus:"
              ),
              _react2.default.createElement("input", { id: "business_id_ro", type: "text", readOnly: true, name: "name", value: business_id.value }),
              _react2.default.createElement(_Input2.default, { id: "business_id", type: "hidden", label: "Y-tunnus", fieldProps: business_id })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-sm-8" },
              _react2.default.createElement(_Input2.default, { id: "company_name", type: "text", label: "Yritys", fieldProps: company_name })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(_Input2.default, { id: "address", type: "text", label: "Katuosoite", fieldProps: address })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-6" },
              _react2.default.createElement(_Input2.default, { id: "postal_code", type: "text", label: "Postinumero", fieldProps: postal_code })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-6" },
              _react2.default.createElement(_Input2.default, { id: "postal_area", type: "text", label: "Paikkakunta", fieldProps: postal_area })
            )
          ),
          this.renderErrorMessage(),
          this.renderSuccessMessage()
        ),
        _react2.default.createElement(_SubmitButton2.default, { text: "Tallenna", submitting: company.companyUpdateLoading || false })
      );
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      var companyUpdateError = this.props.companyProps.companyUpdateError;

      if (companyUpdateError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12 col-md-6 col-md-offset-6" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-message-js" },
            "Tietojen muokkaus ep\xE4onnistui. Tarkista antamasi tiedot tai yrit\xE4 my\xF6hemmin uudelleen!"
          )
        );
      }
    }
  }, {
    key: "renderSuccessMessage",
    value: function renderSuccessMessage() {
      var companyUpdateSuccess = this.props.companyProps.companyUpdateSuccess;

      if (companyUpdateSuccess) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "success-message success-text-js" },
            "Tietojen muokkaus onnistui!"
          )
        );
      }
    }
  }, {
    key: "renderNewUsersTable",
    value: function renderNewUsersTable() {
      if (this.getNewUsers().length) {
        return _react2.default.createElement(
          "div",
          { className: "row new-users-table-js" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Uudet k\xE4ytt\xE4j\xE4t"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "table",
              { className: "table users-table" },
              _react2.default.createElement(
                "thead",
                null,
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "th",
                    null,
                    "Nimi:"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "S\xE4hk\xF6posti:"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "\xA0"
                  )
                )
              ),
              _react2.default.createElement(
                "tbody",
                null,
                this.renderNewUsers()
              )
            )
          )
        );
      }
    }
  }, {
    key: "renderUsers",
    value: function renderUsers() {
      var _this2 = this;

      return this.getUsers().map(function (user) {
        return _react2.default.createElement(
          "tr",
          { key: user.id, className: "user-row-js" },
          _react2.default.createElement(
            "td",
            null,
            user.first_name,
            " ",
            user.last_name
          ),
          _react2.default.createElement(
            "td",
            null,
            user.email
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "select",
              { defaultValue: user.role, className: "change-js", onChange: _this2.changeRole.bind(_this2, user) },
              _react2.default.createElement(
                "option",
                { value: "admin" },
                "Yll\xE4pit\xE4j\xE4"
              ),
              _react2.default.createElement(
                "option",
                { value: "user" },
                "K\xE4ytt\xE4j\xE4"
              )
            )
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "a",
              { href: "#", className: "remove-js", onClick: _this2.removeUser.bind(_this2, user) },
              "Poista"
            )
          )
        );
      });
    }
  }, {
    key: "renderNewUsers",
    value: function renderNewUsers() {
      var _this3 = this;

      return this.getNewUsers().map(function (user) {
        return _react2.default.createElement(
          "tr",
          { key: user.id, className: "new-user-row-js" },
          _react2.default.createElement(
            "td",
            null,
            user.first_name,
            " ",
            user.last_name
          ),
          _react2.default.createElement(
            "td",
            null,
            user.email
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "a",
              { href: "#", className: "approve-js", onClick: _this3.approveUser.bind(_this3, user) },
              "Hyv\xE4ksy"
            )
          )
        );
      });
    }
  }, {
    key: "getUsers",
    value: function getUsers() {
      var users = this.props.company.users;

      return users.filter(function (user) {
        return user.role !== "new";
      });
    }
  }, {
    key: "getNewUsers",
    value: function getNewUsers() {
      var users = this.props.company.users;

      return users.filter(function (user) {
        return user.role === "new";
      });
    }
  }]);
  return CompanyPanel;
}(_react.Component), _class.propTypes = {
  company: _react.PropTypes.object.isRequired,
  updateBillingInfo: _react.PropTypes.func.isRequired,
  changeRole: _react.PropTypes.func.isRequired,
  removeUser: _react.PropTypes.func.isRequired,
  approveUser: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  companyProps: _react.PropTypes.object.isRequired
}, _temp2);
exports.default = CompanyPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/company/CompanyPanel.js
 ** module id = 1148
 ** module chunks = 0
 **/